import React, { useEffect, useRef, useState } from 'react'

import { useDemoControls } from './useDemoControls'

const REQUIRED_CLICKS = 3
const RESET_TIMEOUT_MS = 4000

interface DemoControlsResetDemoButtonProps {
  demoName: string
}

export const DemoControlsResetDemoButton = ({
  demoName,
}: DemoControlsResetDemoButtonProps) => {
  const { resetDemo } = useDemoControls(demoName)
  const [clicks, setClicks] = useState(0)
  const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (resetTimer.current) clearTimeout(resetTimer.current)
    }
  }, [])

  const scheduleReset = () => {
    if (resetTimer.current) clearTimeout(resetTimer.current)
    resetTimer.current = setTimeout(() => setClicks(0), RESET_TIMEOUT_MS)
  }

  const handleClick = async () => {
    const next = clicks + 1
    if (next >= REQUIRED_CLICKS) {
      if (resetTimer.current) clearTimeout(resetTimer.current)
      await resetDemo()
      setClicks(0)
      return
    }
    setClicks(next)
    scheduleReset()
  }

  const remaining = REQUIRED_CLICKS - clicks
  const label =
    clicks === 0
      ? 'Reset Demo'
      : `Click ${remaining} more time${remaining === 1 ? '' : 's'} to confirm reset`

  return (
    <button className='admin-button' onClick={() => { void handleClick() }}>
      {label}
    </button>
  )
}
